import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {DocumentActions, FEATURE} from '../../redux/actions/documents';
import {CommandActions as DocumentCommandActions} from '../../redux/actions/document';
import {CommandActions as DocumentsCommandActions, DocumentActions as DocumentDocumentsActions} from '../../redux/actions/documents';
import {CommandActions as ModalCommandActions} from '../../redux/actions/modal';
import {CommandActions as FiltersCommandActions} from '../../redux/actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import CommandBar from './command_bar/index'
import Notification from '../notification/index';
import { getNotification } from '../../redux/selectors/notification';
import { getFilterPanelOpened } from '../../redux/reducers/ui';
import { getLoader } from '../../redux/selectors/loader';
import { IColumn, MessageBarType, ProgressIndicator, Spinner, SpinnerSize, Selection } from '@fluentui/react';
import { getClassNames } from './index.classNames';
import { getColumns } from '../documents/columns';
import SelectedFilters from '../filtersPanel/filters/selectedFilters';
import _ from 'lodash';
import { getOrderColumn, getTotal } from '../../redux/reducers/documents';
import DocumentModal from '../modals/document'
import DocumentsGrid from '../documents/index'
import { getSelectedProjectUserActions } from '../../redux/selectors/auth';
import { getFilters } from '../../redux/reducers/filters';
import { Filters } from '../../models/filters';
import { getGenericModal, getNotificationWidth } from '../../redux/selectors/ui';
import CalloutFilters from '../filtersPanel/callout/index';
import { MainCompGenerator as GenericModalGenerator, Actions as GenericModalActions } from '@pwbapps/genericdialog'
import UploadFiles from '../documents/functionalities/uploadReplaceFile';
import ChangeStatus from '../documents/functionalities/changeStatus';
import EditDocument from '../documents/functionalities/editDocument';
import DownloadFiles from '../documents/functionalities/downloadFiles';
import DownloadComments from '../documents/functionalities/downloadComments';
import DownloadExcelReport from '../documents/functionalities/downloadExcelReport';
import { InternalRoleActionsType, ExternalRoleActionsType, getTheme } from '../../utils/costants';
import { getHistoryName } from '../../utils/functions';
import { getContextualDocuments } from '../../redux/selectors/documents';
import { FileToDelete, EditDocumentForm, Document, FileForm } from '../../models/document';
import { Status } from '../../models/status';
import { withTranslation, WithTranslation  } from 'react-i18next';
import { getEmail } from '@pwbapps/reduxcore/dist/redux/reducers/auth';
import { getDarkModeEnabled } from '../../redux/reducers/project';
let GenericModal = GenericModalGenerator();

export interface SearchProps extends RouteComponentProps, WithTranslation {
    loading: boolean,
    loadingContent: boolean,
    loadingScroll: boolean,
    documents: Document[]
    filterPanelOpened: boolean, 
    showNotification: boolean, 
    type: MessageBarType, 
    message: string,
    userProjectActions: InternalRoleActionsType[] | ExternalRoleActionsType[],
    filters: Filters,
    showCallout: boolean,
    orderColumn: {name: string, direction: string },
    fileToDelete?: FileToDelete,
    editDocumentForm: EditDocumentForm,
    total: number,
    changeStatusForm?: {
        newStatus: Status,
        fileForm?: FileForm,
        files?: any[]
    },
    uploadFileForm: {files: any[], fileForm: FileForm},
    notificationWidth: string,
    email?: string,
    darkModeEnabled: boolean,
    setSelectedItemsIds: typeof DocumentActions.setSelectedItemsIds
    getDocumentAndOpenModal: typeof DocumentCommandActions.getDocumentAndOpenModal,
    showOrHideCallout: typeof FiltersCommandActions.showOrHideCallout,
    openGenericModal: typeof ModalCommandActions.openModal,
    closeGenericModal: typeof ModalCommandActions.closeModal,
    downloadOrShowFile: typeof DocumentsCommandActions.downloadOrShowFile,
    changeStatus: typeof DocumentsCommandActions.changeStatus,
    deleteFile: typeof DocumentsCommandActions.deleteFile,
    fetchDocuments: typeof DocumentsCommandActions.fetchDocuments,
    setSortColumn: typeof DocumentDocumentsActions.setSortColumn,
    deleteDocuments: typeof DocumentsCommandActions.deleteDocuments,
    editDocument: typeof DocumentsCommandActions.editDocument,
    downloadFiles: typeof DocumentsCommandActions.downloadFiles,
    downloadComments: typeof DocumentsCommandActions.downloadComments,
    downloadExcelReport: typeof DocumentsCommandActions.downloadExcelReport,
    uploadDocuments: typeof DocumentsCommandActions.uploadDocuments,
}
class Search extends React.Component<SearchProps & RouteComponentProps> {
    constructor(props: SearchProps) {
        super(props);   
    }

    getKey = (item: any, index?: number): string => {
        return item.id;
    }

    getFilters = (): Filters => {
        const { filters } = this.props;
        return filters;
    }

    getFilterPanel = (): boolean => {
        const { filterPanelOpened } = this.props;
        return filterPanelOpened;
    }

    onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { fetchDocuments, setSortColumn } = this.props; 
        setSortColumn({colName: column.fieldName as string, direction: (column.isSortedDescending) ? 'asc' : 'desc', feature: FEATURE});
        //this.selection.setAllSelected(false);    
        fetchDocuments({});
    };

    selection = new Selection({		
        getKey: this.getKey,
		onSelectionChanged: () => {
            let rows = this.selection.getSelection() as any;
            const {setSelectedItemsIds} = this.props;
            let ids = (rows) ? _.map(rows, (r: Document) => {return r.id as number}) : [];
            setSelectedItemsIds({ids: _.map(ids, id => id.toString()), feature: FEATURE}) 
		}
    });

    render(){
        const {loading, loadingContent, showNotification, type, message, filterPanelOpened, orderColumn, loadingScroll, userProjectActions, total, changeStatusForm, documents, notificationWidth, email, darkModeEnabled,
               history, fileToDelete, editDocumentForm, uploadFileForm, t, getDocumentAndOpenModal, showOrHideCallout, closeGenericModal, downloadOrShowFile, changeStatus, openGenericModal,
               deleteFile, deleteDocuments, editDocument, downloadFiles, downloadComments, downloadExcelReport, uploadDocuments} = this.props;
        const styles = getClassNames(filterPanelOpened);
        const historyName = getHistoryName(history);
        const showWarningMessage = !((documents.length === 0 && total < 100) || (documents.length > 0 && documents.length < 100));
        const canRead = _.find(userProjectActions, a => a === 'ReadQualityCheck') ? true : false;
        const canDeleteFiles = _.find(userProjectActions, a => a === 'UploadAttachmentQualityCheck' || a === 'UploadCommentFileQualityCheck') ? true : false;
        const canUploadAttachments = _.find(userProjectActions, a => a === 'UploadAttachmentQualityCheck') ? true : false;
        const canUploadFileComments = _.find(userProjectActions, a => a === 'UploadCommentFileQualityCheck') ? true : false;
        const columns = getColumns(email as string, t, canRead, canDeleteFiles, this.selection, this.getFilterPanel, getDocumentAndOpenModal, this.getFilters, showOrHideCallout, downloadOrShowFile, this.onColumnClick, orderColumn, historyName, openGenericModal, undefined, undefined, _.some(userProjectActions, a => a === 'FilterDocumentsByPartnerId'), getTheme(darkModeEnabled));
        return (
            <>
                <CommandBar userProjectActions={userProjectActions} loading={loading} loadingContent={loadingContent} loadingScroll={loadingScroll}/>
                <div style={{position: 'absolute', width: notificationWidth, top: 99, zIndex: 10}}>
                    {!loading && !loadingContent && <Notification name={'qualityCheck'} show={showNotification} type={type} message={message}/>}
                </div>
                <SelectedFilters/>
                <ProgressIndicator styles={{root: {height: 10}}} progressHidden={ !loadingContent || loading }/> 
                {loading && <Spinner size={SpinnerSize.large} style={{marginTop: 50}}></Spinner>}
                {!loading &&
                    <div className={styles.resultContainer}>
                        <DocumentsGrid selection={this.selection} columns={columns} loadingScroll={loadingScroll}/>
                        <DocumentModal userProjectActions={userProjectActions}/>
                    </div>
                }
                <CalloutFilters/>
                <GenericModal 
                    id={'uploadDocuments'}
                    title={(uploadFileForm && uploadFileForm.fileForm && uploadFileForm.fileForm.isParent) ? t('Replace file') : t('Upload files')}
                    message={''}                 
                    onClose={() => {closeGenericModal({id: 'uploadDocuments'})}}
                    btnCloseText={t('Cancel')}
                    btnConfirmText={t('Save')}
                    onConfirm={( )=> {uploadDocuments({})}}
                    disableConfirm={loadingContent || !uploadFileForm || !uploadFileForm.files || uploadFileForm.files.length === 0}
                    customComponent={<UploadFiles loadingContent={loadingContent} canUploadAttachments={canUploadAttachments} canUploadFileComments={canUploadFileComments}/>}
                    disableAutoModalClose 
                    disableClose={loadingContent}  
                    width={640}         
                />
                <GenericModal 
                    id={'changeStatus'}
                    title={t('Change Status')}
                    message={''}                 
                    onClose={() => {}}
                    btnCloseText={t('Cancel')}
                    onConfirm={() => {changeStatus({documents})}}
                    btnConfirmText={t('Save')}
                    customComponent={<ChangeStatus loadingContent={loadingContent}/>}
                    disableConfirm={!changeStatusForm}
                    width={640}
                />
                <GenericModal 
                    id={'editDocument'}
                    title={t('Edit document')}
                    message={''}                 
                    onClose={() => {}}
                    btnCloseText={t('Cancel')}
                    onConfirm={() => {editDocument({editForm: editDocumentForm})}}
                    btnConfirmText={t('Save')}
                    customComponent={<EditDocument loadingContent={loadingContent}/>}
                    disableConfirm={loadingContent || (!editDocumentForm || (editDocumentForm.documentIds.length === 1 && (!editDocumentForm.purpose || !editDocumentForm.clientNumber)) || (editDocumentForm.documentIds.length > 1 && !editDocumentForm.purpose && !editDocumentForm.engPhase))}         
                />
                <GenericModal 
                    id={'fileName'}
                    title={t('Download files')}
                    message={(!showWarningMessage) ? '' : t('Recommended maximum download: 100 documents. Click OK to proceed. Note: Exceeding this may increase download time.')}                 
                    onClose={() => {}}
                    onConfirm={() => {downloadFiles()}}
                    btnConfirmText={t('Download')}
                    btnCloseText={t('Cancel')}   
                    customComponent={<DownloadFiles/>}
                    disableConfirm={loadingContent}     
                />
                <GenericModal 
                    id={'comments'}
                    title={t('Download comments')}
                    message={''}                 
                    onClose={() => {}}
                    onConfirm={() => {downloadComments()}}
                    btnConfirmText={t('Download')}
                    btnCloseText={t('Cancel')}   
                    customComponent={<DownloadComments/>}
                    disableConfirm={loadingContent}     
                />
                <GenericModal 
                    id={'excelReport'}
                    title={t('Download Excel report')}
                    message={''}                 
                    onClose={() => {}}
                    onConfirm={() => {downloadExcelReport()}}
                    btnConfirmText={t('Download')}
                    btnCloseText={t('Cancel')}   
                    customComponent={<DownloadExcelReport/>}
                    disableConfirm={loadingContent}          
                />
                { fileToDelete &&
                    <GenericModal 
                        id={'deleteFile'}
                        title={t('Attention')}
                        message={t('The file')+ ' ' + (fileToDelete.file ? fileToDelete.file.fileName : '') + " " + t("will be deleted. Are you sure?")}             
                        onClose={() => {}}
                        onConfirm={() => {deleteFile({documentId: fileToDelete.documentId , file: fileToDelete.file})}}
                        btnConfirmText={t('Delete')}
                        btnCloseText={t('Cancel')}   
                        disableConfirm={loadingContent}     
                    />
                }
                { documents.length > 0 && 
                    <GenericModal 
                        id={'deleteDocument'}
                        title={t('Attention')}
                        message={((documents.length === 1) ? (t('The document') + documents[0].documentNumber) : (t('The documents') + _.join(_.map(documents, d => d.documentNumber as string), ', '))) + " " + t('will be deleted. Are you sure?')}                    
                        onClose={() => {}}
                        onConfirm={() => {deleteDocuments()}}
                        btnConfirmText={t('Delete')}
                        btnCloseText={t('Cancel')}   
                        disableConfirm={loadingContent}     
                        width={640}
                    />
                }
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    loading: (state) => getLoader('qualityCheck')(state).loading,
    loadingContent: (state) => getLoader('qualityCheck')(state).loadingContent,
    loadingScroll: (state) => getLoader('qualityCheck')(state).loadingScroll,
    showNotification: (state) => getNotification('qualityCheck')(state).show,
    type: (state) => getNotification('qualityCheck')(state).type,
    message: (state) => getNotification('qualityCheck')(state).message,
    filterPanelOpened: getFilterPanelOpened,
    userProjectActions: getSelectedProjectUserActions,
    filters: getFilters,
    changeStatusForm: (state) => (getGenericModal('changeStatus')(state)) ? (getGenericModal('changeStatus')(state) as any).contextItem : undefined,
    orderColumn: getOrderColumn,
    fileToDelete: (state) => (getGenericModal('deleteFile')(state)) ? (getGenericModal('deleteFile')(state) as any).optional as FileToDelete : undefined,
    editDocumentForm: (state) => (getGenericModal('editDocument')(state)) ? (getGenericModal('editDocument')(state) as any).contextItem : undefined,
    uploadFileForm: (state) => (getGenericModal('uploadDocuments')(state)) ? (getGenericModal('uploadDocuments')(state) as any).contextItem : undefined,
    total: getTotal,
    documents : getContextualDocuments,
    notificationWidth: getNotificationWidth,
    email: getEmail,
    darkModeEnabled: getDarkModeEnabled
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setSelectedItemsIds: DocumentActions.setSelectedItemsIds,
        getDocumentAndOpenModal: DocumentCommandActions.getDocumentAndOpenModal,
        showOrHideCallout: FiltersCommandActions.showOrHideCallout,
        openGenericModal: ModalCommandActions.openModal,
        closeGenericModal: ModalCommandActions.closeModal,
        downloadOrShowFile: DocumentsCommandActions.downloadOrShowFile,
        changeStatus: DocumentsCommandActions.changeStatus,
        fetchDocuments: DocumentsCommandActions.fetchDocuments,
        setSortColumn: DocumentDocumentsActions.setSortColumn,
        deleteFile: DocumentsCommandActions.deleteFile,
        deleteDocuments: DocumentsCommandActions.deleteDocuments,
        editDocument: DocumentsCommandActions.editDocument,
        downloadFiles: DocumentsCommandActions.downloadFiles,
        downloadComments: DocumentsCommandActions.downloadComments,
        downloadExcelReport: DocumentsCommandActions.downloadExcelReport,
        uploadDocuments: DocumentsCommandActions.uploadDocuments,
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(withTranslation()(withRouter(Search)));